import React, { useState, useEffect } from 'react';
import styles from '../../app.module.css'

const ParametersList = ({ parameters, currentParameter, onEdit, onDelete, onSave, onCancel }) => {
    const [localParameter, setLocalParameter] = useState(currentParameter);

    useEffect(() => {
        setLocalParameter(currentParameter);
    }, [currentParameter]);

    const handleInputChange = (field, value) => {
        setLocalParameter((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleSchemaChange = (field, value) => {
        setLocalParameter((prev) => ({
            ...prev,
            schema: {
                ...prev.schema,
                [field]: value,
            },
        }));
    };

    const handleCheckboxChange = (field, value) => {
        setLocalParameter((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    return (
        <div>
            {Object.keys(parameters).map((name) => {
                const isEditing = localParameter?.name === name;

                return (
                    <div key={name} className={styles.mainContainer}>
                        {isEditing ? (
                            <>
                                <div className={styles.style3}>
                                    <label>Name:</label>
                                    <input
                                        type="text"
                                        value={localParameter.name}
                                        readOnly
                                        className={styles.textBox}
                                    />
                                </div>

                                <div className={styles.style3}>
                                    <label>Location (in):</label>
                                    <select
                                        value={localParameter.in}
                                        onChange={(e) => handleInputChange('in', e.target.value)}
                                        className={styles.dropdown}
                                    >
                                        <option value="query">Query</option>
                                        <option value="header">Header</option>
                                        <option value="path">Path</option>
                                        <option value="cookie">Cookie</option>
                                    </select>
                                </div>

                                <div className={styles.style3}>
                                    <label>Description:</label>
                                    <input
                                        type="text"
                                        value={localParameter.description}
                                        onChange={(e) => handleInputChange('description', e.target.value)}
                                        className={styles.textBox}
                                    />
                                </div>

                                <div className={styles.style3}>
                                    <label>Required:</label>
                                    <input
                                        type="checkbox"
                                        checked={localParameter.required}
                                        onChange={(e) => handleCheckboxChange('required', e.target.checked)}
                                        style={{
                                            marginLeft: '10px',
                                            transform: 'scale(1.2)',
                                        }}
                                    />
                                </div>

                                <div className={styles.style3}>
                                    <label>Schema Type:</label>
                                    <select
                                        value={localParameter.schema?.type || ''}
                                        onChange={(e) => handleSchemaChange('type', e.target.value)}
                                        className={styles.dropdown}
                                    >
                                        <option value="string">String</option>
                                        <option value="integer">Integer</option>
                                        <option value="boolean">Boolean</option>
                                        <option value="array">Array</option>
                                        <option value="object">Object</option>
                                    </select>
                                </div>

                                <div className={styles.style3}>
                                    <label>Example:</label>
                                    <input
                                        type="text"
                                        value={localParameter.schema?.example || ''}
                                        onChange={(e) => handleSchemaChange('example', e.target.value)}
                                        className={styles.textBox}
                                    />
                                </div>

                                <div className={styles.sNcButtonContainer}>
                                    <button
                                        className={styles.saveButton}
                                        onClick={() => onSave(localParameter.name, localParameter)}
                                    >
                                        Update
                                    </button>
                                    <button
                                        className={styles.cancelButton}
                                        onClick={onCancel}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </>
                        ) : (
                            <>
                                <p>
                                    <strong>Name:</strong> {name}
                                </p>
                                <p>
                                    <strong>Location (in):</strong> {parameters[name].in || 'N/A'}
                                </p>
                                <p>
                                    <strong>Type:</strong> {parameters[name].schema?.type || 'N/A'}
                                </p>
                                <p>
                                    <strong>Description:</strong>{' '}
                                    {parameters[name].description || 'No description'}
                                </p>
                                <p>
                                    <strong>Required:</strong>{' '}
                                    {parameters[name].required ? 'Yes' : 'No'}
                                </p>
                                <p>
                                    <strong>Example:</strong>{' '}
                                    {parameters[name].schema?.example || 'No example'}
                                </p>

                                <div className={styles.actionButtonsContainer}>
                                    <button
                                        className={styles.editButton}
                                        onClick={() => onEdit(name)}
                                    >
                                        Edit
                                    </button>
                                    <button
                                        className={styles.deleteButton}
                                        onClick={() => onDelete(name)}
                                    >
                                        Delete
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default ParametersList;
